import React from 'react'
import { Card } from '@saasalerts/ui'
import { SomethingWentWrong } from '@/components/Errors'

type HeaderProps = {
  title?: string
  icon?: any
  color?: any
}

export type ChartCardProps = {
  header: HeaderProps
  accessory?: React.ReactNode
  accessoryPosition?: React.ComponentProps<typeof Card>['accessoryPosition']
  error?: boolean
  loading?: boolean
  noData?: boolean
  overlayText?: string
  children: React.ReactNode
  className?: string
}

/**
 * ChartCard
 * A thin wrapper around the shared `Card` that centralizes the common
 * chart states: error, no-data overlay, and normal children rendering.
 *
 * Styling is inherited from `Card`; no additional CSS classes are introduced
 * beyond optional `className`/`bodyClassName` passthroughs.
 */
export const ChartCard: React.FC<ChartCardProps> = ({
  header,
  accessory,
  accessoryPosition,
  error,
  children,
  className,
}) => {
  return (
    <Card
      accessory={accessory}
      accessoryPosition={accessoryPosition}
      className={`print:break-inside-avoid-page ${
        className ? ` ${className}` : ''
      }`}
    >
      <Card.Header
        title={header?.title}
        icon={header?.icon}
        color={header?.color}
      />
      <Card.Body>
        <div className="echartContainer relative mt-2 meticulous-ignore">
          {children}
          {error && <SomethingWentWrong className="absolute z-20" />}
        </div>
      </Card.Body>
    </Card>
  )
}

export default ChartCard
